import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import styles from './index.module.css';
import cn from 'classnames';

export default function Input({ type = 'text', ...props }) {
  const [showPassword, setShowPassword] = useState(false);

  // Если это поле для пароля
  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  return (
    <div className={styles.wrapper}>
      <input {...props} type={inputType} />
      {isPassword && (
        <span
          className={cn(styles.icon, styles.showIcon, showPassword && styles.active)}
          onClick={() => setShowPassword((prev) => !prev)}
          role="button"
          aria-label="Показать или скрыть пароль"
        >
          {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
        </span>
      )}
    </div>
  );
}
